/**
 * @generated SignedSource<<662619487832f1e95d67f3a97649202b>>
 * @relayHash 4417ce4ebf9c8d1cd541a20d4dd4102e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c2cd9b41617a4a16517b982d04a397d4ead9ffde8cfac315767f4f62c98c9903

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StakeholdersPageQuery$variables = {
  cloudId: string;
};
export type StakeholdersPageQuery$data = {
  readonly stakeholderComms_getStakeholdersByAssignmentV2: {
    readonly " $fragmentSpreads": FragmentRefs<"StakeholderPageContent">;
  };
};
export type StakeholdersPageQuery = {
  response: StakeholdersPageQuery$data;
  variables: StakeholdersPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Literal",
            "name": "assignmentType",
            "value": "SITE"
          },
          {
            "kind": "Variable",
            "name": "externalAssignmentId",
            "variableName": "cloudId"
          }
        ],
        "kind": "ObjectValue",
        "name": "assignmentIdInput"
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 10
      }
    ],
    "kind": "ObjectValue",
    "name": "stakeholderConnectionInput"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "avatar"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "StakeholdersPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "concreteType": "StakeholderCommsStakeholderConnection",
          "kind": "LinkedField",
          "name": "stakeholderComms_getStakeholdersByAssignmentV2",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "StakeholderPageContent"
            }
          ]
        },
        "action": "THROW",
        "path": "stakeholderComms_getStakeholdersByAssignmentV2"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StakeholdersPageQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "StakeholderCommsStakeholderConnection",
        "kind": "LinkedField",
        "name": "stakeholderComms_getStakeholdersByAssignmentV2",
        "plural": false,
        "selections": [
          {
            "concreteType": "StakeholderCommsStakeholder",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "name": "type"
              },
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "concreteType": "StakeholderCommsGroups",
                "kind": "LinkedField",
                "name": "groups",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v3/*: any*/)
                ]
              },
              {
                "concreteType": "StakeholderCommsNotificationPreference",
                "kind": "LinkedField",
                "name": "notificationPreference",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "emailId"
                  },
                  (v2/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "status"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c2cd9b41617a4a16517b982d04a397d4ead9ffde8cfac315767f4f62c98c9903",
    "metadata": {},
    "name": "StakeholdersPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2c0c6dfdb70cc260f6d8513302d493ea";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
